import { useEffect } from 'react';

const useBodyBackgroundColor = (color) => {
  useEffect(() => {
    const originalBodyColor = window
      .getComputedStyle(document.body, null)
      .getPropertyValue('background-color');
    document.body.style.backgroundColor = color;

    return () => {
      document.body.style.backgroundColor = originalBodyColor;
    };
  }, []);
};

export default useBodyBackgroundColor;
